<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <woot-modal-header :header-title="$t('PIPELINES.SELECT_DATE')" />
    <div class="remainder-table">
      <div class="remainder-modal">
        <div class="remainder-input date-time">
          <div class="date-time-input">
            <label>
              {{ $t('PIPELINES.CHOOSE_DATE_FROM') }}
              <date-picker
                type="datetime"
                :confirm="true"
                :clearable="true"
                :editable="true"
                :append-to-body="false"
                format="YYYY-MM-DD HH:mm"
                :placeholder="$t('PIPELINES.PLACEHOLDER_START_DATE')"
                v-model="scheduledAtFrom"
                @change="onDateChangeFrom"
              />
            </label>
            <label>
              {{ $t('PIPELINES.CHOOSE_DATE_END') }}
              <date-picker
                type="datetime"
                :confirm="true"
                :clearable="true"
                :editable="true"
                :append-to-body="false"
                format="YYYY-MM-DD HH:mm"
                :placeholder="$t('PIPELINES.PLACEHOLDER_END_DATE')"
                v-model="scheduledAtTo"
                @change="onDateChangeTo"
              />
            </label>
          </div>
        </div>
      </div>
      <p v-if="scheduledAtFrom && scheduledAtTo && scheduledAtFrom > scheduledAtTo" style="color: red; font-size: 13px; margin-top: -20px;">
        {{ 'Start date must be greater than end date.' }}
      </p>

      <div class="flex justify-end items-center pb-6 pt-2 gap-2 w-full">
        <woot-submit-button
          :disabled="uiFlags.isFetchingContacts || isSubmitDisabled"
          :button-text="'Submit'"
          class="button-color"
          @click="sendDate"
        />
        <woot-button class="button clear cancel-btn" @click.prevent="onClose">
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex';

export default {
  components: {
    DatePicker,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    includeHour: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      scheduledAtFrom: null,
      scheduledAtTo: null,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'pipelines/getUIFlags',
    }),
  isSubmitDisabled() {
      if (!this.scheduledAtFrom || !this.scheduledAtTo) {
        return true;
      }
      return this.scheduledAtFrom > this.scheduledAtTo;
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onDateChangeFrom(value) {
      this.scheduledAtFrom = value;
    },
    onDateChangeTo(value) {
      this.scheduledAtTo = value;
    },
    parseDateTime(dateObj) {
      if (!dateObj || !(dateObj instanceof Date)) return null;

      const pad = (num) => String(num).padStart(2, '0');
      const year = dateObj.getFullYear();
      const month = pad(dateObj.getMonth() + 1);
      const day = pad(dateObj.getDate());
      const hours = pad(dateObj.getHours());
      const minutes = pad(dateObj.getMinutes());

      return {
        date: `${year}-${month}-${day}`,
        time: `${hours}:${minutes}`,
      };
    },
    sendDate() {
      if (!this.scheduledAtFrom || !this.scheduledAtTo) return;

      const parsedFrom = this.parseDateTime(this.scheduledAtFrom);
      const parsedTo = this.parseDateTime(this.scheduledAtTo);

      this.$emit('update-date', {
        scheduledAtFrom: parsedFrom,
        scheduledAtTo: parsedTo,
      });

      this.onClose();
    },
  },
};
</script>

<style scoped>
::v-deep .modal-container {
  border-radius: 12px;
  overflow: visible;
}

.remainder-table {
  margin: 10px 35px;
}

.remainder-modal {
  display: flex;
}

.remainder-input {
  width: 100%;
}

.date-time {
  display: flex;
  justify-content: space-between;
}

.date-time-input {
  width: 100%;
}

.cancel-btn {
  background-color: #fff;
  color: #40518a;
}

.cancel-btn:hover {
  background-color: #f9f9f9;
  color: #40518a;
}

.button-color {
  background-color: #40518a;
  color: #fff;
}

.date-time-input label {
  display: flex;
  flex-direction: column;
  width: 48%;
  margin-bottom: 1rem;
}

.date-time-input {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.date-time-input ::v-deep .mx-datepicker {
  width: 100%;
}

.date-time-input ::v-deep .mx-datepicker-popup {
  top: 100% !important;
  left: 0 !important;
  z-index: 9999;
}

.date-time-input ::v-deep .mx-input {
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #d1d5db; 
  border-radius: 4px;
  background-color: #fff;
  color: #374151; 
  transition: border-color 0.2s ease-in-out;
}

.date-time-input ::v-deep .mx-input:focus {
  outline: none;
  border-color: #40518a; 
  box-shadow: 0 0 0 2px rgba(64, 81, 138, 0.2);
}

.date-time-input label span {
  font-size: 12px;
  margin-top: 4px;
}
</style>
